'use client'

import { useState } from 'react'
import { Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface WeekendFaq {
  q: string
  a: string
}

/** Lightweight accordion with no extra dependency, keyboard accessible via buttons. */
export function WeekendFaq({ items }: { items: WeekendFaq[] }) {
  const [open, setOpen] = useState<number | null>(0)
  return (
    <div className="overflow-hidden rounded-[1.75rem] border border-border bg-card">
      {items.map((f, i) => {
        const isOpen = open === i
        return (
          <div key={f.q} className={cn(i < items.length - 1 && 'border-b border-border')}>
            <button
              onClick={() => setOpen(isOpen ? null : i)}
              aria-expanded={isOpen}
              className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
            >
              <span className="text-[15px] font-semibold">{f.q}</span>
              <span
                className={cn(
                  'flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-border transition-transform duration-300',
                  isOpen && 'rotate-45 bg-brand text-white',
                )}
              >
                <Plus className="h-4 w-4" />
              </span>
            </button>
            <div
              className={cn(
                'grid transition-all duration-300 ease-out',
                isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
              )}
            >
              <div className="overflow-hidden">
                <p className="px-6 pb-6 text-sm leading-6 text-muted-foreground">{f.a}</p>
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
